<template>
<div class = 'evalution container' >
	<h2>Evaluation de {{voc.name.replace(/_/g," ")}}</h2>
     <b-progress class="mt-2" :max="max" show-value>
       <b-progress-bar :value="success" variant="success"></b-progress-bar>
       <b-progress-bar :value="warning" variant="warning"></b-progress-bar>
       <b-progress-bar :value="danger" variant="danger"></b-progress-bar>
     </b-progress>
	 <hr>
	<b-card :title="'Question n° '+(questionNb)">
		<div class = 'card-body'>
			<h4 class = 'row' v-if = '!finished'>
				<div class = 'col-12 col-sm-4 my-3'><strong>{{question}}</strong></div>
				<div class = 'col-12 col-sm-4 my-3 answer text-info' ><strong >{{(showAnswer)?answer:"???"}}</strong></div>
				<div class = "col-12 col-sm-4 text-center my-3">
					<button type = 'button' class="btn btn-secondary btn-lg m-2" @click="lastQuestion" v-if="last_question[0] && !showAnswer">annuler</button>
					<button type = 'button' class=" btn btn-primary btn-lg m-2" v-if='!showAnswer' @click="showAnswer=true">réponse</button>
					
					<span v-if = "showAnswer">
						<button type = 'button' class = 'btn btn-warning m-2 btn-lg' @click="torepeat">à répéter</button>
						<button type = 'button' class = 'btn btn-success m-2 btn-lg' @click="oksuccess">juste !</button>
					</span>
				</div>
			</h4>
		</div>
	</b-card> 
	
	<b-card :title="'Résultat: '+(success-errors.length)+'/'+(voc.terms.length*2)" v-if = 'finished'>
		<p v-if="errors.length"><strong>A répéter: </strong></p>
		<dl class = 'row' v-if="errors.length" v-for="(error,k) in errors" :key="k">
			<dt class = 'col-6 text-right'>{{error[0]}}</dt>
			<dd class = 'col-6 text-left'>{{error[1]}}</dd>
		</dl>
		<p class = 'center'>
			<button type = 'button' class = 'btn btn-primary' router link to="/">retour</button>
		</p>
	</b-card>
	
</div>
</template>

<script>
import {mapGetters} from 'vuex'

function shuffle(a) {
	for (let i = a.length - 1; i > 0; i--) {
		const j = Math.floor(Math.random() * (i + 1));
		[a[i], a[j]] = [a[j], a[i]];
	}
	return a;
}


export default {
	name: 'Evalutaion',
	data () {
		return {
			success: 0,
			warning: 0,
			danger: 0,
			question: '',
			last_question: [],
			questions: [],
			errors: [],
			showAnswer: false,
			questionNb: 0,
			finished: false
		}
	},
	computed: {
		...mapGetters(
			{
				vocs: 'vocs'
			}
		),
		voc () {
			let voc = {
				name: '',
				language: '',
				terms: []
			}
			let params = this.$route.params.voc.split(";")
			_.forEach(this.vocs, v => {
				if (params.indexOf(v.name) > -1){
					voc.name += " "+v.name
					voc.name = voc.name.trim()
					voc.language = v.language
					voc.terms = voc.terms.concat(v.terms);
				}
			})
			return voc
		},
		max () {
			return this.voc.terms.length*2 + this.errors.length
		}
	},
	methods: {
		nextQuestion () {
			if (!this.questions.length){
				if (this.errors.length){
					this.$store.dispatch('setRepeat',{
						name: this.voc.name,
						language: this.voc.language,
						terms: this.errors
					})
				}
				this.finished = true
				return
			} 
			this.questionNb++;
			this.last_question = [this.question,this.answer]
			let question = this.questions.shift();
			this.question = question[1];
			this.answer = question[0];
		},
		oksuccess () {
			this.success++;
			this.showAnswer = false
			this.nextQuestion()
		},
		torepeat () {
			let error = [this.question,this.answer];
			this.questions.push(error);
			if (this.answer && this.question){
				error = [this.answer,this.question];
				this.questions.push(error);
				this.questions = shuffle(this.questions)
				if (this.errors.indexOf(error) > -1) this.danger++;
				else {
					this.warning++;
					this.errors.push(error)
				}				
			}
			this.showAnswer = false
			this.nextQuestion()
		},
		keyenter () {
			if (!this.showAnswer) this.showAnswer = true;
			else this.oksuccess()
		},
		lastQuestion () {
			if (!this.last_question[0]) return
			this.questions.unshift([this.question,this.answer])
			this.question = this.last_question[0];
			this.answer = this.last_question[1]
			this.last_question = []
			this.success--;
			this.questionNb--;
			this.showAnswer = true
		}
	},
	mounted () {
		let vm = this
		_.forEach(this.voc.terms,t => {
			this.questions.push(t);
			if (t[0] != t[1]) this.questions.push([t[1],t[0]])
		})
		this.questions = shuffle(this.questions);
		this.nextQuestion()
		window.addEventListener('keyup', function(event) {
	      if (event.keyCode === 13) { 
			  vm.keyenter();
	      }
	      else if (event.keyCode === 27) { 
			  if (vm.showAnswer){
				  vm.torepeat();			  	
			  }
			  else if (vm.last_question[0]){
			  	vm.lastQuestion()
			  }
	      }

	    });
	}
}
</script>

<style scoped>
div.answer {
	font-size: 1.4em;
	padding: 0px 10px;
	border: 1px solid #17a2b8!important;
}
h4 span {
	vertical-align: center;
}
h2 {
	text-transform:capitalize;
}
</style>